import { UiElement } from '../../ui/UiElement.js';

export { Attribution };

/**
 * Simple map zoom tool
 *
 * @author rhess <robin.hess@awi.de>
 * 
 * @memberof vef.map
 */
class Attribution extends UiElement {

    constructor(map, position) {
        super();

        this.map = map;
        this.position = position || "bottom-right";

        this.update();

        this.map.addTool(this, this.position);
        this.map.on("baselayer_change", () => this.update())
    }

    update() {
        const element = this.getElement();
        element.classList.add("vef-map-attribution");
        element.innerHTML = (this.map.baseLayer_ && this.map.baseLayer_.attribution) ? this.map.baseLayer_.attribution : "";
    }
}